export const enum PageState{
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error',
    Init = 'Init'
}

